import React, { useEffect } from 'react';

/**
 * SafeSEO: Un componente ligero para manejar SEO en React 18
 * Sustituye a react-helmet para evitar errores fatales de renderizado.
 */
const SafeSEO = ({ title, description, url, imageUrl }) => {
  const siteName = 'Consulting Logistic, S.A.';
  const fullTitle = title ? `${title} | ${siteName}` : siteName;

  useEffect(() => {
    // 1. Actualizar el título de la pestaña
    document.title = fullTitle;

    // 2. Función auxiliar para actualizar meta-tags
    const updateMeta = (property, attrName, value) => {
      if (!value) return;
      let element = document.querySelector(`meta[${attrName}="${property}"]`);
      if (element) {
        element.setAttribute('content', value);
      } else {
        const meta = document.createElement('meta');
        meta.setAttribute(attrName, property);
        meta.setAttribute('content', value);
        document.head.appendChild(meta);
      }
    };

    // 3. Actualizar meta-tags básicos
    updateMeta('description', 'name', description);
    
    // 4. Actualizar Open Graph (Facebook/LinkedIn)
    updateMeta('og:title', 'property', fullTitle);
    updateMeta('og:description', 'property', description);
    updateMeta('og:url', 'property', url || window.location.href);
    if (imageUrl) {
      updateMeta('og:image', 'property', imageUrl);
    }

    // 5. Actualizar Twitter Cards
    updateMeta('twitter:title', 'name', fullTitle);
    updateMeta('twitter:description', 'name', description);
    if (imageUrl) {
      updateMeta('twitter:image', 'name', imageUrl);
    }

  }, [fullTitle, description, url, imageUrl]);

  return null; // Este componente no renderiza nada en el DOM visible
};

export default SafeSEO;
